export interface ObbRouteOption {
  value: string;
  label: string;
  stationCode: string;
}

export const mapAirlineStationToRouteOption = (station: any): ObbRouteOption | null => {
  if (!station?.name) {
    return null;
  }

  const stationCode = station?.station_code != null ? String(station.station_code).trim() : "";
  if (!stationCode) {
    return null;
  }

  return {
    value: station.name,
    label: station.name,
    stationCode
  };
};
